<template>
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M15.974 4.765a.881.881 0 0 1 1.33 1.153l-.068.078-8.776 8.998a.881.881 0 0 1-1.183.072l-.078-.07-4.044-4.127a.881.881 0 0 1 1.182-1.303l.076.07 3.413 3.483 8.148-8.354z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
